export const SET_EVENT_ATTENDANCE_LOADING = "SET_EVENT_ATTENDANCE_LOADING";
export const SET_EVENT_ATTENDANCE_SUBMITTING = "SET_EVENT_ATTENDANCE_SUBMITTING";
export const SET_EVENT_ATTENDANCE_ERROR = "SET_EVENT_ATTENDANCE_ERROR";

export const FETCH_EVENT_ATTENDANCE_REQUEST = "FETCH_EVENT_ATTENDANCE_REQUEST";
export const FETCH_EVENT_ATTENDANCE_SUCCESS = "FETCH_EVENT_ATTENDANCE_SUCCESS";
export const FETCH_EVENT_ATTENDANCE_FAILURE = "FETCH_EVENT_ATTENDANCE_FAILURE";

export const BULK_UPDATE_EVENT_ATTENDANCE_REQUEST = "BULK_UPDATE_EVENT_ATTENDANCE_REQUEST";
export const BULK_UPDATE_EVENT_ATTENDANCE_SUCCESS = "BULK_UPDATE_EVENT_ATTENDANCE_SUCCESS";
export const BULK_UPDATE_EVENT_ATTENDANCE_FAILURE = "BULK_UPDATE_EVENT_ATTENDANCE_FAILURE";

export const DECLARE_MY_EVENT_ABSENCE_REQUEST = "DECLARE_MY_EVENT_ABSENCE_REQUEST";
export const DECLARE_MY_EVENT_ABSENCE_SUCCESS = "DECLARE_MY_EVENT_ABSENCE_SUCCESS";
export const DECLARE_MY_EVENT_ABSENCE_FAILURE = "DECLARE_MY_EVENT_ABSENCE_FAILURE";

export const setEventAttendanceLoading = (value) => ({
    type: SET_EVENT_ATTENDANCE_LOADING,
    payload: value,
});

export const setEventAttendanceSubmitting = (value) => ({
    type: SET_EVENT_ATTENDANCE_SUBMITTING,
    payload: value,
});

export const setEventAttendanceError = (error) => ({
    type: SET_EVENT_ATTENDANCE_ERROR,
    payload: error,
});

export const fetchEventAttendanceRequest = (eventId) => ({
    type: FETCH_EVENT_ATTENDANCE_REQUEST,
    payload: { eventId },
});

export const fetchEventAttendanceSuccess = (eventId, items) => ({
    type: FETCH_EVENT_ATTENDANCE_SUCCESS,
    payload: { eventId, items },
});

export const fetchEventAttendanceFailure = (error) => ({
    type: FETCH_EVENT_ATTENDANCE_FAILURE,
    payload: error,
});

export const bulkUpdateEventAttendanceRequest = (eventId, items) => ({
    type: BULK_UPDATE_EVENT_ATTENDANCE_REQUEST,
    payload: { eventId, items },
});

export const bulkUpdateEventAttendanceSuccess = (eventId, result) => ({
    type: BULK_UPDATE_EVENT_ATTENDANCE_SUCCESS,
    payload: { eventId, result },
});

export const bulkUpdateEventAttendanceFailure = (error) => ({
    type: BULK_UPDATE_EVENT_ATTENDANCE_FAILURE,
    payload: error,
});

export const declareMyEventAbsenceRequest = (eventId, payload) => ({
    type: DECLARE_MY_EVENT_ABSENCE_REQUEST,
    payload: { eventId, payload },
});

export const declareMyEventAbsenceSuccess = (eventId, result) => ({
    type: DECLARE_MY_EVENT_ABSENCE_SUCCESS,
    payload: { eventId, result },
});

export const declareMyEventAbsenceFailure = (error) => ({
    type: DECLARE_MY_EVENT_ABSENCE_FAILURE,
    payload: error,
});
